module.exports = "<ng-container *ngFor=\"let item of tr.order\"><span *ngIf=\"item === ccEl.TEXT; else timeBlock\">{{tr.translate('contributions', count)}}</span><ng-template #timeBlock><time *ngIf=\"item === ccEl.DATE; else countBlock\" [attr.datetime]=\"date.toISOString()\">{{date.toLocaleDateString()}}</time><ng-template #countBlock><span class=\"count\" *ngIf=\"count !== 0 || !tr.hideZero\">{{count.toLocaleString()}}</span></ng-template></ng-template></ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/GhContribCalendar/DayDetails/DayDetails.pug
// module id = 35
// module chunks = 0 1